export const validateDob = (rawValue, errorMessage) => {
  const value = (rawValue || "").replace(/[^0-9]/g, "");

  if (value.length !== 8) {
    return errorMessage || "Enter a valid date";
  }

  const year = parseInt(value.substring(0, 4), 10);
  const month = parseInt(value.substring(4, 6), 10);
  const day = parseInt(value.substring(6, 8), 10);

  const currentYear = new Date().getFullYear();
  if (Number.isNaN(year) || year < 1900 || year > currentYear) {
    return errorMessage || "Enter a valid date";
  }

  if (Number.isNaN(month) || month < 1 || month > 12) {
    return errorMessage || "Enter a valid date";
  }

  if (Number.isNaN(day) || day < 1 || day > 31) {
    return errorMessage || "Enter a valid date";
  }

  const date = new Date(year, month - 1, day);
  const isValidDate =
    date.getFullYear() === year &&
    date.getMonth() === month - 1 &&
    date.getDate() === day;

  if (!isValidDate) {
    return errorMessage || "Enter a valid date";
  }

  return null;
};

export const normalizeDob = (rawValue) =>
  (rawValue || "").replace(/[^0-9]/g, "").slice(0, 8);

